import huebSeoProductDetail from './plugin.store';

const { Component, Store } = Shopware;
const { Criteria } = Shopware.Data;

Component.override('sw-product-detail', {

    inject: ['repositoryFactory'],

    beforeCreate() {
        Store.register('huebSeoProductDetail', huebSeoProductDetail);
    },

    beforeDestroy() {
        Store.unregister('huebSeoProductDetail');
    },

    computed: {
        richSnippets: () => Store.get('huebSeoProductDetail').richSnippets,

        huebRichSnippetsRepository() {
            return this.repositoryFactory.create('hueb_seo_ultimate_rich_snippets');
        },
    },

    methods: {
        /*      extended functions to provide additional state managment for plugin data      */

        //set api context for plugin state
        initState() {
            // Shopware.State.commit('huebSeoProductDetail/setApiContext', Shopware.Context.api);
            Store.get('huebSeoProductDetail').apiContext = Shopware.Context.api;
            this.$super('initState');
        },

        //set local mode to false when product exists
        loadState() {
            // Shopware.State.commit('huebSeoProductDetail/setLocalMode', false);
            Store.get('huebSeoProductDetail').localMode = false;
            this.$super('loadState');
        },

        //save plugin data before product is saved
        saveProduct() {
            // Shopware.State.commit('swProductDetail/setLoading', ['product', true]); //set product loading to 'true' first
            Store.get('huebSeoProductDetail').setLoading(['product', true]);

            // Shopware.State.commit('huebSeoProductDetail/setLoading', ['richSnippets', true]);
            Store.get('huebSeoProductDetail').setLoading(['richSnippets', true]);

            this.huebRichSnippetsRepository.save(this.richSnippets, Shopware.Context.api)
                .then(() => {
                    //Shopware.State.commit('huebSeoProductDetail/setLoading', ['richSnippets', false]);
                    Store.get('huebSeoProductDetail').setLoading(['richSnippets', false]);
                }).catch((response) => {
                    //Shopware.State.commit('huebSeoProductDetail/setLoading', ['richSnippets', false]);
                    Store.get('huebSeoProductDetail').setLoading(['richSnippets', false]);
            });

            return this.$super('saveProduct'); //important to use return to correctly pass Promise
        },

        //create state when product is new, must be called after createState() to have a valid product.id
        // .then() possible because crateState() returns a Promise
        createState() {
            return this.$super('createState').then(() => {
                this.createRichSnippetsState();
            });
        },

        //load existing product and plugin data accordingly
        loadProduct() {
            // Shopware.State.commit('swProductDetail/setLoading', ['product', true]); //set product loading to 'true' first
            Store.get('swProductDetail').setLoading(['product', true]);
            // Shopware.State.commit('huebSeoProductDetail/setLoading', ['richSnippets', true]);
            Store.get('huebSeoProductDetail').setLoading(['richSnippets', true]);

            const richCriteria = new Criteria();
            richCriteria.addFilter(Criteria.equals('productId', this.productId || this.product.id));
            this.huebRichSnippetsRepository.search(richCriteria, Shopware.Context.api)
                .then((entity) => {
                    if(entity.length) {
                        //Shopware.State.commit('huebSeoProductDetail/setRichSnippets', entity[0]);
                        Store.get('huebSeoProductDetail').setRichSnippets(entity[0]);
                    } else {
                        this.createRichSnippetsState();
                    }
                });
            this.$super('loadProduct');
        },

        //load Rich Snippets from parent, if they exist
        loadParentProduct() {
            // Shopware.State.commit('swProductDetail/setLoading', ['parentProduct', true]); //set parentProduct loading to 'true' first
            Store.get('swProductDetail').setLoading(['parentProduct', true]);
            // Shopware.State.commit('swProductDetail/setLoading', ['parentRichSnippets', true]);
            Store.get('swProductDetail').setLoading(['parentRichSnippets', true]);

            const richCriteria = new Criteria();
            richCriteria.addFilter(Criteria.equals('productId', this.product.parentId));
            this.huebRichSnippetsRepository.search(richCriteria, Shopware.Context.api)
                .then((entity) => {
                    if(entity.length) {
                        //Shopware.State.commit('huebSeoProductDetail/setParentRichSnippets', entity[0]);
                        Store.get('huebSeoProductDetail').setParentRichSnippets(entity[0]);
                    } else {
                        //Shopware.State.commit('huebSeoProductDetail/setParentRichSnippets', {});
                        Store.get('huebSeoProductDetail').setParentRichSnippets({});
                    }
                }).then(() => {
                    //Shopware.State.commit('swProductDetail/setLoading', ['parentRichSnippets', false]);
                    Store.get('swProductDetail').setLoading(['parentRichSnippets', false]);
                });

            this.$super('loadParentProduct');
        },

        /*      additional plugin functions      */
        //creates plugin data entry if necessary (for new and existing products with no associated plugin data)
        createRichSnippetsState() {
            // Shopware.State.commit('huebSeoProductDetail/setLocalMode', true);
            Store.get('huebSeoProductDetail').localMode = true;
            // Shopware.State.commit('huebSeoProductDetail/setLoading', ['richSnippets', true]);
            Store.get('huebSeoProductDetail').setLoading(['richSnippets', true]);

            // Shopware.State.commit('huebSeoProductDetail/setRichSnippets', this.huebRichSnippetsRepository.create(Shopware.Context.api));
            Store.get('huebSeoProductDetail').setRichSnippets(this.huebRichSnippetsRepository.create(Shopware.Context.api));

            if(typeof this.product.id !== 'undefined') {
                this.richSnippets.productId = this.product.id;
            } else {
                this.richSnippets.productId = this.productId;
            }

            // Shopware.State.commit('huebSeoProductDetail/setLoading', ['richSnippets', false]);
            Store.get('huebSeoProductDetail').setLoading(['richSnippets', false]);
        }
    }

});
